import React from "react";

const Button = ({ text, link }) => {
  return (
    <>
      <div className="row">
        <div className="projects__btn center">
          <a
            href={link}
            target="_blank"
            className="btn"
            rel="noopener noreferrer"
          >
            {text}
          </a>
        </div>
      </div>
    </>
  );
};

export default Button;
